<template>
  <Dialog :open="state.open">
    <DialogContent class="rounded-lg z-[100]" overlay-class="z-[100]" hide-close @interact-outside.prevent="() => {}">
      <DialogHeader>
        <DialogTitle>{{ state.title }}</DialogTitle>
        <DialogDescription>{{ state.description }}</DialogDescription>
      </DialogHeader>
      <div class="max-h-[40vh] overflow-y-auto">
        <component :is="state.extras" v-if="state.extras" />
      </div>
      <DialogFooter>
        <Button @click="resolve()">{{ state.buttonText }}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
const { state, resolve } = useWarning()
</script>
